export default {
  // Nav & Language
  nav_brand: 'AllChinaBuy Spreadsheet',
  nav_home: 'Home',
  nav_categories: 'Categories',
  nav_guides: 'Shopping Guide',
  nav_faq: 'FAQ',
  lang_switch: 'Language',
  lang_en: 'English',
  lang_fr: 'Français',
  lang_de: 'Deutsch',
  lang_da: 'Dansk',

  // Hero
  hero_h1: 'AllChinaBuy Spreadsheet — Find Products, Sellers & Buying Guides',
  hero_subtitle: 'Discover the latest AllChinaBuy spreadsheet resources, popular products, trusted seller information, QC tips, shipping guides and practical buying advice — all in one place.',
  hero_cta_primary: 'Explore AllChinaBuy Spreadsheet',
  hero_cta_secondary: 'Browse Popular Finds',
  hero_trust: 'Updated resources • Independent information • Beginner-friendly guides',
  hero_support_title: 'Looking for an AllChinaBuy Spreadsheet?',
  hero_support_desc: 'Find useful product lists, seller resources, category guides, QC information, shipping advice and AllChinaBuy buying tips without searching across dozens of websites. Whether you are completely new to AllChinaBuy or already use buying agents regularly, our resource hub helps you research products and make better-informed purchasing decisions.',

  // What Is Section
  whatis_title: 'What Is AllChinaBuy Spreadsheet?',
  whatis_desc: 'An AllChinaBuy spreadsheet is a curated collection of product links, seller information, buying guides, and quality control tips compiled to help shoppers find the best items through the AllChinaBuy buying agent platform.',
  step_find: 'Find',
  step_find_desc: 'Browse curated product lists and seller directories organized by category.',
  step_research: 'Research',
  step_research_desc: 'Compare sellers, check QC photos, and review shipping options before buying.',
  step_buy: 'Buy',
  step_buy_desc: 'Order confidently with verified resources and practical buying guides.',

  // Categories Section
  categories_title: 'Popular Spreadsheet Categories',
  categories_subtitle: 'Explore organized product categories to find exactly what you need through AllChinaBuy.',
  cat_shoes: 'Shoes',
  cat_hoodies: 'Hoodies / Sweaters',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jackets',
  cat_pants: 'Pants / Shorts',
  cat_headwear: 'Headwear',
  cat_sets: 'Sets',
  cat_underwear: 'Underwear / Underpants',
  cat_jersey: 'Jersey',
  cat_accessories: 'Accessories',
  cat_bags: 'Bags',
  cat_belts: 'Belts',
  cat_perfumes: 'Perfumes',
  cat_other: 'Other Stuff',
  cat_fashion: 'Fashion',
  cat_streetwear: 'Streetwear',
  cat_sportswear: 'Sportswear',
  cat_electronics: 'Electronics',
  cat_home: 'Home & Lifestyle',
  cat_popular: 'Popular Finds',

  // Featured Section
  featured_title: 'Featured AllChinaBuy Spreadsheet Resources',
  featured_subtitle: 'A curated overview of products, sellers, and guides to help you navigate AllChinaBuy efficiently.',
  col_product: 'Product',
  col_category: 'Category',
  col_seller: 'Seller',
  col_qc: 'QC',
  col_guide: 'Guide',
  col_action: 'Action',
  action_view: 'View Details',

  // Guides Section
  guides_title: 'Popular AllChinaBuy Guides',
  guide_spreadsheet: 'AllChinaBuy Spreadsheet Guide',
  guide_review: 'AllChinaBuy Review',
  guide_shipping: 'AllChinaBuy Shipping Cost',
  guide_coupon: 'AllChinaBuy Coupon',
  guide_discount: 'AllChinaBuy Discount Code',
  guide_warehouse: 'AllChinaBuy Warehouse',
  guide_legit: 'Is AllChinaBuy Legit?',
  guide_qc: 'AllChinaBuy QC Guide',
  guide_order: 'How to Order from AllChinaBuy',
  guide_buying: 'AllChinaBuy Buying Guide',
  guide_read: 'Read Guide',

  // Why Use Section
  why_title: 'Why Use This Resource?',
  why_organized_title: 'Organized Resources',
  why_organized_desc: 'Find useful AllChinaBuy spreadsheet information in one place.',
  why_buying_title: 'Buying Guides',
  why_buying_desc: 'Understand products, sellers, QC, shipping and ordering.',
  why_compare_title: 'Comparison Research',
  why_compare_desc: 'Compare AllChinaBuy with other buying-agent platforms.',
  why_safety_title: 'Safety Information',
  why_safety_desc: 'Learn how to identify risks and make informed decisions.',

  // Comparison Section
  compare_title: 'AllChinaBuy vs Other Buying Agents',
  compare_subtitle: 'Compare key features and differences between AllChinaBuy and other popular buying agent platforms.',
  compare_feature: 'Feature',
  compare_allchinabuy: 'AllChinaBuy',
  compare_superbuy: 'Superbuy',
  compare_cssbuy: 'CSSBuy',
  compare_sugargoo: 'Sugargoo',
  compare_pandabuy: 'PandaBuy',
  compare_check: 'Check current availability',

  // Safety Section
  safety_title: 'Shop Smarter with AllChinaBuy Safety Guides',
  safety_desc: 'Before placing any order, learn essential safety practices that protect your money, your data, and your shopping experience.',
  safety_seller_title: 'Seller Research',
  safety_seller_desc: 'Learn how to verify sellers before committing to a purchase.',
  safety_qc_title: 'QC Photos',
  safety_qc_desc: 'Understand why quality control photos matter and how to request them.',
  safety_link_title: 'Suspicious Links',
  safety_link_desc: 'Identify red flags in product listings and seller pages.',
  safety_payment_title: 'Payment Safety',
  safety_payment_desc: 'Use secure payment methods and understand buyer protections.',
  safety_shipping_title: 'Shipping Risks',
  safety_shipping_desc: 'Navigate customs, insurance, and delivery considerations.',
  safety_refund_title: 'Refund Considerations',
  safety_refund_desc: 'Know your rights and platform policies before you buy.',

  // FAQ Section
  faq_title: 'Frequently Asked Questions',
  faq_q1: 'What is an AllChinaBuy spreadsheet?',
  faq_a1: 'An AllChinaBuy spreadsheet is a curated collection of product links, seller references, buying guides, and tips organized to help buyers navigate the AllChinaBuy buying agent platform efficiently. It includes categories like shoes, clothing, bags, accessories, and more.',
  faq_q2: 'Is AllChinaBuy a legitimate buying agent?',
  faq_a2: 'AllChinaBuy is a buying agent platform that connects international shoppers with Chinese sellers. Like all buying agents, legitimacy depends on current service quality, user experiences, and proper due diligence. Our guides help you verify information before purchasing.',
  faq_q3: 'How do I use an AllChinaBuy spreadsheet?',
  faq_a3: 'Start by browsing the product categories that match what you are looking for. Research the seller, check for available QC photos, review shipping costs, and follow our step-by-step buying guides for a smoother experience.',
  faq_q4: 'What shipping options does AllChinaBuy offer?',
  faq_a4: 'AllChinaBuy typically offers multiple shipping lines including EMS, DHL, FedEx, and various postal services. Shipping costs vary by destination, weight, and chosen method. Check current rates directly with AllChinaBuy as they change frequently.',
  faq_q5: 'Are there AllChinaBuy coupons or discount codes?',
  faq_a5: 'Coupon availability changes over time. Some platforms offer seasonal promotions, referral discounts, or first-time user savings. We track and update available coupon information in our dedicated coupon guide.',
  faq_q6: 'How do I check QC photos on AllChinaBuy?',
  faq_a6: 'Quality control photos are usually available in your order dashboard after items arrive at the warehouse. Request detailed QC photos before shipping to verify product condition, size, and color accuracy.',
  faq_q7: 'What is the AllChinaBuy warehouse process?',
  faq_a7: 'After purchase, sellers ship items to the AllChinaBuy warehouse. Items are inspected, photographed (QC), and stored. You can then review, consolidate, and ship your parcel to your destination address.',
  faq_q8: 'How do I compare AllChinaBuy with other buying agents?',
  faq_a8: 'Compare based on shipping rates, service fees, QC photo quality, customer support responsiveness, and user reviews. Our comparison section provides a structured way to evaluate these factors.',

  // Final CTA
  final_cta_title: 'Ready to Explore the AllChinaBuy Spreadsheet?',
  final_cta_desc: 'Browse organized resources, product guides and useful buying information in one place.',
  final_cta_primary: 'Explore AllChinaBuy Spreadsheet',
  final_cta_secondary: 'View All Categories',

  // External CTA buttons
  ext_btn_main: 'AllChinaBuy Spreadsheet',
  ext_btn_buy: 'Buy It Now',

  // Footer
  footer_disclaimer: 'This website provides independent informational content and does not guarantee product quality, seller behavior, shipping outcomes, refunds or platform performance. Users should verify current information before making purchases.',
  footer_about: 'About',
  footer_policy: 'Editorial Policy',
  footer_contact: 'Contact',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Use',
  footer_copyright: 'AllChinaBuy Spreadsheet. Independent informational resource.',

  // Article Page
  article_breadcrumb_home: 'Home',
  article_breadcrumb_article: 'Article',
  article_read_time: 'min read',
  article_updated: 'Updated',
  article_related: 'Related Resources',
  article_back_home: 'Back to Home',
  article_author: 'Research Team',
  article_share: 'Share this guide',
  article_toc: 'Table of Contents',
  article_intro: 'Introduction',
  article_conclusion: 'Conclusion',
  article_cta_text: 'Explore more AllChinaBuy resources and find the best products for your needs.',
  article_cta_button: 'Browse All Resources',
};